import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router";
import imgs from "../assets/images/imgs";
import AddAdmin from "../components/Add Profile/AddAdmin";
import AddProfilePopup from "../components/Add Profile/AddProfilePopup";
import AddSchool from "../components/AddSchool/AddSchool";
import Sidebar from "../components/Sidebar/Sidebar";
import MobileSidebarDrawer from "../components/Sidebar/MobileSidebarDrawer";
import { TABLET_DRAWER_BREAKPOINT } from "../context/SidebarDrawerContext";
import Students from "../components/Students/Students";
import Teachers from "../components/Teachers/Teachers";
import ShowAdminDashboard from "../modules/admin/Dashboard/Dashboard";
import AllCourses from "../modules/admin/courses/AllCourses";
import AllCoursesDashboard from "../modules/superadmin/AllCoursesDashboard/AllCoursesDashboard";
import RatingCard from "../modules/superadmin/Rating/Rating";
import SchoolList from "../modules/superadmin/SchoolList/SchoolList";
import SuperAdminDashboard from "../modules/superadmin/dashboard/Dashboard";
import StudentDashboard from "../pages/home/components/dashboard/student/StudentDashboard";
import Message from "../pages/home/components/dashboard/teacher/Tab/Message";
import TeacherDashboard from "../pages/home/components/dashboard/teacher/TeacherDashboard";
import CreateCourse from "../pages/home/components/dashboard/teacher/course/CreateCourse";
import Settings from "../pages/home/components/settings/Settings";
import { useAuth } from "../features/auth/AuthContext";
import CustomSingleButtonPopup from "../components/CustomSingleButtonPopup/CustomSingleButtonPopup";
import OverallPerformanceDashboard from "../components/OverallPerformanceDashboard/OverallPerformanceDashboard";
import Home from "../components/FileRepo/Pages/Home";
import Favourites from "../components/FileRepo/Pages/Favourites";
import ActivityLog from "../components/FileRepo/Pages/ActivityLog";
import Bin from "../components/FileRepo/Pages/Bin";
import Main from "../components/FileRepo/Components/Main";
import LearningSpecialist from "../components/LearningSpecialist/LearningSpecialist";
import Advisors from "../components/Advisors/Advisors";
import Departments from "../components/Departments/Departments";
import EnrolledStudents from "../pages/home/components/dashboard/teacher/Tab/EnrolledStudents";
import MyDepartmentHod from "../pages/home/components/dashboard/teacher/Tab/MyDepartmentHod";
import BackButton from "../components/BackButton/BackButton";
import RevenueComponent from "../components/RevenueComponent/RevenueComponent";
import Meetings from "../components/BookAMeeting/Meetings";
import useBranding from "../hooks/useBranding";


const dropdownOptions = [
  { key: "Favourites", route: "favourites", Component: Favourites },
  { key: "Activity Log", route: "activity", Component: ActivityLog },
  { key: "Bin", route: "bin", Component: Bin },
]




function Dashboard() {
  const globalState = useSelector((state) => state.globalState);
  const brandconfig = useBranding();
  const location = useLocation();
  const urlLocation = location.pathname.split("/")[location.pathname.split("/").length - 1];
  const { logout, token, isLoggingOut } = useAuth()
  const role = globalState.role;
  const navigate = useNavigate();
  const teacherRole = globalState?.teacher_details?.data?.teacher_department_roles
  const isHOD = teacherRole === "hod";
  // Marketplace module — ProSchool only (gates My Earnings sidebar item)
  const isMarketplace = globalState?.enabled_modules?.includes('marketplace');
  const isGoogleMeet = globalState?.enabled_modules?.includes('google_meet');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  const tabs = [
  {
    key: "Dashboard",
    value: imgs.svg.dashboard_sidebar,
    role: "Teacher",
    route: "home",
    Component: TeacherDashboard
  },
 ...(isHOD
    ? [{
        key: "My Department",
        value: imgs.svg.dept_logo,
        role: "Teacher",
        route: "my-department",
        Component: MyDepartmentHod,
      }]
    : (teacherRole === "advisor" || teacherRole === "learning specialist")
    ? [{
        key: " My Students",
        value: imgs.svg.students_profile,
        role: "Teacher",
        route: "students",
        Component: EnrolledStudents,
      }]
    : []),
  { key: "Analytics", value: imgs.svg.disable_icon, role: "Teacher", route: "analytics", Component: OverallPerformanceDashboard },
  { key: brandconfig.filename || "My Files", value: imgs.svg.folder_icon, role: "Teacher", route: "files", Component: Main, dropdown: dropdownOptions },
  // My Earnings — ProSchool (marketplace) only
  ...(isMarketplace
    ? [{ key: "My Earnings", value: imgs.svg.wallet_add, role: "Teacher", route: "revenue-details", Component: RevenueComponent }]
    : []),
  { key: "Message", value: imgs.svg.sms_sidebar, role: "Teacher", route: "messages", Component: Message },
   ...(isMobile && isGoogleMeet
    ? [{ key: "Meetings", value: imgs.svg.calendar, role: "Teacher", route: "meetings", Component: Meetings }]
    : []),
  { key: "Settings", value: imgs.svg.setting_sidebar, role: "Teacher", route: "settings", Component: Settings, props: { isDashboard: true } },
  // Meetings — Mobile only for Teacher
 
  {
    key: "Dashboard",
    value: imgs.svg.dashboard_sidebar,
    role: "SuperAdmin",
    route: "home",
    Component: SuperAdminDashboard
  },
  {
    key: "Teachers",
    value: imgs.svg.teachers_profile,
    role: "SuperAdmin",
    route: "teachers",
    Component: Teachers,
  },
  {
    key: "Students",
    value: imgs.svg.students_profile,
    role: "SuperAdmin",
    route: "students",
    Component: Students,
  },
  {
    key: "Schools",
    value: imgs.svg.schools,
    role: "SuperAdmin",
    route: "schools",
    Component: SchoolList,
  },
  {
    key: "Courses",
    value: imgs.svg.book,
    role: "SuperAdmin",
    route: "courses",
    Component: AllCoursesDashboard,
  },
  {
    key: "Ratings",
    value: imgs.svg.rating_star,
    role: "SuperAdmin",
    route: "ratings",
    Component: RatingCard
  },
  {
    key: "Dashboard", value: imgs.svg.dashboard_sidebar, role: "Admin", route: "home",
    Component: ShowAdminDashboard
  },
  {
    key: "Teachers", value: imgs.svg.teachers_profile, role: "Admin", route: "teachers",
    Component: Teachers,
  },
  {
    key: "Students", value: imgs.svg.students_profile, role: "Admin", route: "students",
    Component: Students,
  },
  {
    key: "Courses", value: imgs.svg.book, role: "Admin", route: "courses",
    Component: AllCourses,
  },
  {
    key: "Advisor", value: imgs.svg.advisor_logo, role: "Admin", route: "advisors",
    Component: Advisors,
  },
  {
    key: "Learning Specialist", value: imgs.svg.specialist_logo, role: "Admin", route: "learning-specialist",
    Component: LearningSpecialist,
  },
  {
    key: "Departments", value: imgs.svg.dept_logo, role: "Admin", route: "departments",
    Component: Departments,
  },
];

  const tabList = tabs.filter((tab) => tab.role === role);
  let selectedTab;

  // if (role === "Student") {
  //   selectedTab = "";
  // } else {
  //   selectedTab = urlLocation.length ? tabList.find((tab) => tab.route === urlLocation)?.key : tabList[0].key;
  // }

  const [activeTab, setActiveTab] = useState(tabList[0]?.key || "");
  const [entity, setEntity] = useState("");
  const [showCourse, setShowCourse] = useState(false);
  const [addSchool, setAddSchool] = useState(false);
  const [addAdmin, setaddAdmin] = useState(false);
  const [showAddProfile, setShowshowAddProfile] = useState(false);
  const [popup, setPopup] = useState(false);

useEffect(() => {
  if (role !== "Student") {
    const currentRoute = location.pathname.split("/").pop();

    const currentSelectedTab = tabList.find(
      (tab) => tab.route === currentRoute
    )?.key;

    if (currentSelectedTab && currentSelectedTab !== activeTab) {
      setActiveTab(currentSelectedTab);
    }
  }
}, [location.pathname, tabList, role, activeTab]);

  const toggleAddSchool = (overflow) => {
    setAddSchool(!addSchool);
  };

  const toggleCourse = (overflow) => {
    setShowCourse(!showCourse);
  };

  const handleCancelPopup = () => {
    logout();
    setPopup(false);
  };

  const toggleshowAddProfile = (overflow, entity) => {
    setShowshowAddProfile(!showAddProfile);
    setEntity(entity);
  }

  const toggleAddAdmin = () => {
    setaddAdmin(!addAdmin)
  }


  if (isLoggingOut?.current) {
    return null;
  }

  if ((!globalState.role || !token) && !popup) {
    setPopup(true)
    return;
  }
  return (
    <>
      {popup ?
        <CustomSingleButtonPopup
          title={'Your session has expired. Please log in again to continue.'}
          btn1={'Login'}
          btn1Click={handleCancelPopup}
        /> :
        role === "Student" ? (
          <StudentDashboard />
        ) :
          <div className="dashboard">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12 col-md-12 gx-0 gx-lg-3">
                  <div className="dashboardBody">
                    {role !== "Student" && (
                      <>
                        <Sidebar
                          activeTab={activeTab}
                          setActiveTab={setActiveTab}
                          tabList={tabList}
                          toggleCourse={toggleCourse}
                          toggleAddSchool={toggleAddSchool}
                          toggleshowAddProfile={toggleshowAddProfile}
                          toggleAddAdmin={toggleAddAdmin}
                          dropdownOptions={dropdownOptions}
                        />
                        {/* Same sidebar, opened from the header hamburger on mobile and tablet */}
                        <MobileSidebarDrawer breakpoint={TABLET_DRAWER_BREAKPOINT}>
                          <Sidebar
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            tabList={tabList}
                            toggleCourse={toggleCourse}
                            toggleAddSchool={toggleAddSchool}
                            toggleshowAddProfile={toggleshowAddProfile}
                            toggleAddAdmin={toggleAddAdmin}
                            dropdownOptions={dropdownOptions}
                          />
                        </MobileSidebarDrawer>
                      </>
                    )}
                    <div className="dashboardMainBody">
                     {/* { role === "SuperAdmin" || role=== "Admin" ? <BackButton onClick={() => navigate("/dashboard/home")} buttonName="Back" /> : null } */}
                      <Routes>
                        <Route path="/" element={<Navigate to="/dashboard/home" />} />
                        <Route path="meetings" element={<Meetings />} />
                        {tabList.map((tab) => (
                          <Route key={tab.key} path={tab.route} element={
                            React.createElement(tab.Component, tab.props ? tab.props : {})
                          } />
                        ))}
                      
                        {dropdownOptions.map((tab) => (
                          <Route key={tab.key} path={tab.route} element={
                            React.createElement(tab.Component, tab.props ? tab.props : {})
                          } />
                        ))}
                         <Route path="*" element={<Navigate to="/ErrorPagenotFound" />} />
                      </Routes>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
      {showCourse && (
        <CreateCourse
          setShowCourse={setShowCourse}
          toggleCourse={toggleCourse}
        />
      )}

      {addSchool && (
        <AddSchool setAddSchool={addSchool} toggleAddSchool={toggleAddSchool} />
      )}

      {showAddProfile && <AddProfilePopup toggleshowAddProfile={toggleshowAddProfile} entity={entity} />}

      {addAdmin && <AddAdmin toggleAddAdmin={toggleAddAdmin} />}
    </>
  );
}

export default Dashboard;
